export default {
  EAT_SYMBOLS: 'symbols',
  EAT_BIG_WIN: 'bigWin_spine',
  EAT_BACKGROUND: 'background',
  SYMBOL_FRAME_AND_FIRE: 'symbolFrameAndFire',
  EAT_JACKPOT: 'jackpot'
}
